import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'hk-text',
  template: `
    <span #textContent class="overflow-hidden overflow-ellipsis whitespace-nowrap"><ng-content></ng-content></span>
  `,
  host: { class: 'flex items-center overflow-hidden min-w-0' },
  standalone: true,
})
export class TextComponent {
  @ViewChild('textContent', { read: ElementRef }) textContent!: ElementRef;

  constructor(private hostElement: ElementRef) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const element = this.textContent.nativeElement;
    if (element.offsetWidth < element.scrollWidth) {
      this.hostElement.nativeElement.title = element.textContent;
    } else if (this.hostElement.nativeElement.title) {
      this.hostElement.nativeElement.removeAttribute('title');
    }
  }
}
